import styled from '@emotion/styled';
import Button from '../../Button';

export const Estimate = styled.div`
  display: flex;
  min-height: 16px;
`;

export const TotalEstimate = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Header = styled.div`
  display: flex;
  color: #5e6c84;
  white-space: nowrap;
  font-weight: 600;
  line-height: 20px;
  font-size: 12px;
`;

export const Text = styled.div`
  display: flex;
  font-size: 14px;
`;

export const LightText = styled.div`
  display: flex;
  color: #6b778c;
  font-size: 12px;
  line-height: 15px;
  margin-left: 3px;
`;

export const EditEstimateButton = styled(Button)`
`;

export const AvatarsGroup = styled.div`
  display: flex;
`;

export const GroupedAvatar = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

export const Tooltip = styled.div`
  display: flex;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MarginLeft = styled.div`
  margin-left: 4px;
`;

export const TooltipText = styled.div`
  display: flex;
`;

export const Story = styled.div`
  display: flex;
`;
